module.exports = __webpack_public_path__ + "img/empty-cart.7f1ab9c0.jpg";